export const rootPaths = Object.freeze({
  static: {
    root: '/',
    notFound: '/404',
    forbidden: '/403',
    privacyPolicy: '/privacy-policy',
    termsAndConditions: '/terms-and-conditions',
  },
});
